import React from "react"
import ReactDOM from "react-dom"
import Handsontable from "handsontable"
import * as numbro from "handsontable/node_modules/numbro"

export default (cellComponent, row, props, col) => {
	return function (instance, td, r, c, prop, value, cellProperties) {
		switch (cellProperties.type) {
			case "numeric":
				Handsontable.renderers.NumericRenderer.apply(this, arguments)
				value = numbro(value).format(cellProperties.format || '0')
				break
			default:
				Handsontable.renderers.BaseRenderer.apply(this, arguments)
		}

		const element = <cellComponent.component
		{...props}
		cellProperties={cellProperties}
		col={col}
		row={row}
		value={value}
		td={td} />

		ReactDOM.render(element, td)
		return td
	}
}



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/utils/cell-renderer.js